<div class="operation-popover">
  <span class="operation-popover-title">{{title}}</span>
  <span class="operation-popover-text">{{text}}</span>
  <div class="operation-popover-actions">
    <fw-button (click)="onCancelClick.emit()" color="danger" variant="outline">{{cancelTitle}}</fw-button>
    <fw-button (click)="onSubmitClick.emit()" color="danger">{{submitTitle}}</fw-button>
  </div>
</div>
